<template>
  <div class="assistant-wrapper">
    <div class="assistant" @mouseenter="openModal()">
      <div class="assistant__content">
        <div class="tab-content">
          <div class="tab-pane fade" :class="{show: isOpen === 'assistant-profile', active: isOpen === 'assistant-profile'}" id="assistant-profile" role="tabpanel" :aria-label='$t("profile")'>
            <div class="assistant__header assistant__header_mobile d-flex d-xl-none">
              <div class="assistant__title section__title section__title_style3">{{$t("assistant")}}</div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="closeModal" type="button" :aria-label='$t("close")'><span
                    class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__header d-none d-xl-flex">
              <div class="assistant__icon"><img class="assistant__avatar" src="/images/content/user2.png" :alt='$t("photo")'/>
              </div>
              <div class="assistant__fio">
                <div class="assistant__surname">{{ profile.last_name }}</div>
                <div class="assistant__name">{{ profile.first_name }} {{ profile.patronymic }}</div>
              </div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="closeModal" type="button" :aria-label='$t("close")'><span
                    class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body">
              <div class="scrollbar-outer">
                <div class="assistant__header d-flex d-xl-none">
                  <div class="assistant__icon"><img class="assistant__avatar" src="images/content/user.png" :alt='$t("photo")'/>
                  </div>
                  <div class="assistant__fio">
                    <div class="assistant__surname">{{ profile.last_name }}</div>
                    <div class="assistant__name">{{ profile.first_name }} {{ profile.patronymic }}</div>
                  </div>
                </div>
                <ul class="list list_unstyled assistant__info-list">
                  <li class="list__item info-item">
                    <div class="info-item__icon color-green_light" aria-hidden="true"><span class="svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-assigment"></use>
                            </svg></span></div>
                    <div class="info-item__content">
                      <div class="info-item__title">{{$t("personalAccount")}}:</div>
                      <div class="info-item__value">
                        {{ profile.id_client ? subStr(String(profile.id_client)) : $t("missing") }}
                      </div>
                    </div>
                  </li>
                  <li class="list__item info-item">
                    <div class="info-item__icon color-green_light" aria-hidden="true"><span class="svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-wallet"></use>
                            </svg></span></div>
                    <div class="info-item__content">
                      <div class="info-item__title">{{$t("balance")}}:</div>
                      <div class="info-item__value">
                        {{ personalData.ContractObject ? formatOBK(personalData.ContractObject[0].obk || 0) + " " + $t("tenge") : $t("missing") }}
                      </div>
                    </div>
                  </li>
                  <li class="list__item info-item">
                    <div class="info-item__icon color-green_light" aria-hidden="true"><span class="svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-place"></use>
                            </svg></span></div>
                    <div class="info-item__content">
                      <div class="info-item__title">{{$t("city")}}:</div>
                      <div class="info-item__value" v-if="profile.profile">{{ nursultanToAstana(profile.profile.city) }}</div>
                    </div>
                  </li>
                  <li class="list__item info-item">
                    <div class="info-item__icon color-green_light" aria-hidden="true"><span class="svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-person-pin"></use>
                            </svg></span></div>
                    <div class="info-item__content">
                      <div class="info-item__title">{{$t("address")}}:</div>
                      <div class="info-item__value" v-if="profile.profile">{{ profile.profile.address }}</div>
                    </div>
                  </li>
                  <li class="list__item info-item">
                    <div class="info-item__icon color-green_light" aria-hidden="true"><span class="svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-assigment"></use>
                            </svg></span></div>
                    <div class="info-item__content">
                      <div class="info-item__title">{{$t("phone")}}:</div>
                      <div class="info-item__value">{{ (profile.phone && profile.phone.length > 9) ? `+7 ${profile.phone}` : $t("unknown")}}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div class="assistant__footer">
              <div class="assistant__short">
                <button class="btn btn_icon" @click.prevent.stop="openAssistant('assistant-helper')" type="button"
                        :aria-label='$t("onlineHelper")' data-target="#assistant-helper"><span class="svg-icon">
                        <svg role="img" width="24" height="24" aria-hidden="true">
                          <use xlink:href="#svg-icon-assistant"></use>
                        </svg></span></button>
              </div>
              <div class="assistant__long">
                <button class="btn btn_default btn_white" @click.prevent.stop="openAssistant('assistant-chat')"
                        type="button" :aria-label='$t("onlineHelper")' data-target="#assistant-chat">{{$t("onlineHelper")}}
                </button>
              </div>
            </div> -->
          </div>

          <div class="tab-pane fade" :class="{show: isOpen === 'assistant-helper', active: isOpen === 'assistant-helper'}"  id="assistant-helper" role="tabpanel" :aria-label='$t("onlineHelper")'>
            <div class="assistant__header assistant__header_mobile">
              <div class="assistant__icon" aria-hidden="true"><span class="svg-icon">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-assistant"></use>
                      </svg></span></div>
              <div class="assistant__title section__title section__title_style3"><span class="line">{{$t("online")}} </span><span
                  class="line">{{$t("helper")}}</span></div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="openAssistant('assistant-profile')" type="button"
                        data-target="#assistant-profile" :aria-label='$t("close")'><span class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body assistant__body_bordered assistant__body_short">
              <div class="scrollbar-outer">
                <div class="assistant__subtitle section__title section__title_style3">{{$t("helpText")}}</div>
                <div class="assistant__descr section__description"><a class="link" href="tel:191">{{$t("contactCenter")}}</a></div>
              </div>
            </div>
            <div class="assistant__footer">
              <div class="assistant__full">
                <button class="btn btn_default btn_white btn_with-icon"
                        @click.prevent.stop="openAssistant('assistant-call')" type="button"
                        data-target="#assistant-call"><span class="btn__icon svg-icon" aria-hidden="true">
                        <svg role="img" width="24" height="24" aria-hidden="true">
                          <use xlink:href="#svg-icon-phone2"></use>
                        </svg></span><span class="btn__text">{{$t("requestCall")}}</span></button>
                <button class="btn btn_default btn_white btn_with-icon"
                        @click.prevent.stop="openAssistant('assistant-chat')" type="button"
                        data-target="#assistant-chat"><span class="btn__icon svg-icon" aria-hidden="true">
                        <svg role="img" width="24" height="24" aria-hidden="true">
                          <use xlink:href="#svg-icon-chat"></use>
                        </svg></span><span class="btn__text">{{$t("onlineConsultant")}}</span></button>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" :class="{show: isOpen === 'assistant-call', active: isOpen === 'assistant-call'}"
               id="assistant-call" role="tabpanel" :aria-label='$t("requestCall")'>
            <div class="assistant__header assistant__header_mobile">
              <div class="assistant__icon" aria-hidden="true"><span class="svg-icon">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-phone2"></use>
                      </svg></span></div>
              <div class="assistant__title section__title section__title_style3"><span
                  class="line">{{$t("requestCall")}}</span></div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="openAssistant('assistant-profile')" type="button"
                        data-target="#assistant-profile" :aria-label='$t("close")'><span class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body assistant__body_bordered">
              <div class="scrollbar-outer">
                <div class="form">
                  <div id="call-order-form">
                    <div class="form-group">
                      <label class="form-label form-label_hidden" for="user-name-af">{{$t("name", {sym: "*"})}}</label>
                      <input class="form-control" v-model="dataForACallBack.fio" :class="{is_invalid: v$.dataForACallBack.fio.$error}" type="text" name="user-name-af" id="user-name-af" :placeholder='$t("name", {sym: "*"})'/>
                      <div class="form-validator" :class="{is_invalid: v$.dataForACallBack.fio.$error}">{{$t("requiredInput")}}</div>
                    </div>
                    <div class="form-group">
                      <label class="form-label form-label_hidden" for="user-tel-af">{{$t("phoneNumber", {sym: "*"})}}</label>
                      <input class="form-control" v-model="dataForACallBack.phone" :class="{is_invalid: v$.dataForACallBack.phone.$error}" type="tel" v-mask="'+7 (###) ### ## ##'" placeholder="+7 - - - - - - - - - - *" name="user-tel-af" id="user-tel-af"/>
                      <div class="form-validator" :class="{is_invalid: v$.dataForACallBack.phone.$error}">{{$t("requiredInput")}}</div>
                    </div>
                    <!-- <div class="form-group">
                      <label class="form-label form-label_hidden" for="user-address-af">Адрес *</label>
                      <input class="form-control" v-model="dataForACallBack.address" :class="{is_invalid: v$.dataForACallBack.address.$error}" type="text" name="user-address-af" id="user-address-af" placeholder="Адрес *" />
                      <div class="form-validator" :class="{is_invalid: v$.dataForACallBack.address.$error}">Заполните это поле</div>
                    </div> -->
                    <!-- <div class="form-group">
                      <label class="form-label form-label_hidden" for="user-address-af">Номер контракта *</label> -->
                      <!-- <select class="form-control" v-model="dataForACallBack.contract_number" :class="{is_invalid: v$.dataForACallBack.contract_number.$error}" name="user-address-af" id="user-address-af">
                        <option value="" disabled selected>Номер контракта *</option>
                        <option v-for="contractNum in personalData.ContractObject" :key="contractNum.idContract" :value="contractNum.numberContract">{{contractNum.numberContract}}</option>
                      </select> -->
                      <!-- <input class="form-control" v-model="dataForACallBack.iin" :class="{is_invalid: v$.dataForACallBack.iin.$error}" type="text" name="user-iin" id="user-iin" placeholder="ИИН *" />
                      <div class="form-validator" :class="{is_invalid: v$.dataForACallBack.iin.$error}">Заполните это поле</div>
                    </div> -->
                    <div class="form-group">
                      <label class="form-label form-label_hidden" for="user-subject-af">{{$t("questionText", {sym: "*"})}}</label>
                      <input class="form-control" v-model="dataForACallBack.question" :class="{is_invalid: v$.dataForACallBack.question.$error}" type="text" name="user-subject-af" id="user-subject-af" :placeholder='$t("questionText", {sym: "*"})'/>
                      <div class="form-validator" :class="{is_invalid: v$.dataForACallBack.question.$error}">{{$t("requiredInput")}}</div>
                    </div>
                    <div class="checkbox">
                      <label class="checkbox__label" for="user-agreement-af">
                        <input class="checkbox__hidden" v-model="isAgree" type="checkbox" id="user-agreement-af" name="user-agreement-af"
                                :value='$t("agreeReg")'/><span class="checkbox__custom"
                                                                                        aria-hidden="true">
                              <svg role="img" width="10" height="10">
                                <use xlink:href="#svg-icon-check"></use>
                              </svg></span><span class="checkbox__title">{{$t("agreeText")}} <a
                          class="link" href="/doc/ПубличныйДоговор.pdf"
                          target="_blank">"{{$t("publicContract")}}"</a></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="assistant__footer">
              <div class="assistant__full">
                <button :disabled="!isAgree || loading" :class="{is_disabled: !isAgree}" class="btn btn_default btn_white btn_with-icon"
                        @click.prevent.stop="requestACall('assistant-call-success')" type="submit"
                        data-target="#assistant-call-success">
                  <span class="btn__icon svg-icon" aria-hidden="true">
                    <svg v-if="!loading" role="img" width="24" height="24" aria-hidden="true">
                      <use xlink:href="#svg-icon-phone2"></use>
                    </svg>
                    <img v-else src="images/content/loader.gif" alt='loader'/>
                  </span>
                  <span class="btn__text">{{$t("order")}}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="tab-pane fade"
               :class="{show: isOpen === 'assistant-call-success', active: isOpen === 'assistant-call-success'}"
               id="assistant-call-success" role="tabpanel" :aria-label='$t("responseText")'>
            <div class="assistant__header assistant__header_mobile">
              <div class="assistant__icon" aria-hidden="true"><span class="svg-icon">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-phone2"></use>
                      </svg></span></div>
              <div class="assistant__title section__title section__title_style3"><span
                  class="line">{{$t("order")}} </span><span class="line">{{$t("call")}}</span></div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="openAssistant('assistant-profile')" type="button"
                        data-target="#assistant-profile" :aria-label='$t("close")'><span class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body assistant__body_bordered">
              <div class="scrollbar-outer">
                <div class="assistant__subtitle section__title section__title_style3">{{$t("thanks") }}</div>
                <div class="assistant__descr section__description">
                  <p>{{$t("responseText")}}</p>
                </div>
              </div>
            </div>
            <div class="assistant__footer">
              <div class="assistant__full">
                <button class="btn btn_default btn_white" @click.prevent.stop="openAssistant('assistant-profile')"
                        type="button" data-target="#assistant-profile">{{$t("toMain")}}
                </button>
              </div>
            </div>
          </div>
          <div class="tab-pane fade"
               :class="{show: isOpen === 'assistant-call-error', active: isOpen === 'assistant-call-error'}"
               id="assistant-call-error" role="tabpanel" :aria-label='$t("responseText")'>
            <div class="assistant__header assistant__header_mobile">
              <div class="assistant__icon" aria-hidden="true"><span class="svg-icon">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-phone2"></use>
                      </svg></span></div>
              <div class="assistant__title section__title section__title_style3"><span
                  class="line">{{$t("order")}} </span><span class="line">{{$t("call")}}</span></div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="openAssistant('assistant-profile')" type="button"
                        data-target="#assistant-profile" :aria-label='$t("close")'><span class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body assistant__body_bordered">
              <div class="scrollbar-outer">
                <div class="assistant__subtitle section__title section__title_style3">{{$t("error")}}</div>
                <div class="assistant__descr section__description">
                  <p>{{$t("errorMessage")}}</p>
                </div>
              </div>
            </div>
            <div class="assistant__footer">
              <div class="assistant__full">
                <button class="btn btn_default btn_white" @click.prevent.stop="openAssistant('assistant-profile')"
                        type="button" data-target="#assistant-profile">{{$t("toMain")}}
                </button>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" :class="{show: isOpen === 'assistant-chat', active: isOpen === 'assistant-chat'}"
               id="assistant-chat" role="tabpanel" :aria-label='$t("onlineConsultant")'>
            <div class="assistant__header assistant__header_mobile">
              <div class="assistant__icon" aria-hidden="true"><span class="svg-icon">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-chat"></use>
                      </svg></span></div>
              <div class="assistant__title section__title section__title_style3"><span class="line">{{$t("online")}} </span><span
                  class="line">{{$t("consultant")}}</span></div>
              <div class="assistant__close">
                <button class="btn btn_close" @click.prevent.stop="openAssistant('assistant-profile')" type="button"
                        data-target="#assistant-profile" :aria-label='$t("close")'><span class="svg-icon">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg></span></button>
              </div>
            </div>
            <div class="assistant__body assistant__body_bordered">
              <div class="scrollbar-outer">
                <div class="assistant__chat">
                  <div class="assistant__message" v-for="message in dialog" :key="message.id"
                       :class="message.owner === 'user' ? 'assistant__message_user' : 'assistant__message_bot'">
                    <ul class="services" v-if="message.type === 'category'">
                      <li class="service service__title">{{$t("assistantMessageTitle")}}</li>
                      <li class="service" v-for="mess in message.answer" :key="mess.id"
                          @click.prevent.stop="getSubCategoryByCategory(mess.id)">
                        <span>{{ mess.name }}</span>
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-arrow-next"></use>
                        </svg>
                      </li>
                    </ul>
                    <ul class="services" v-else-if="message.type === 'subCategory'">
                      <div class="service__block">
                        <li class="service" v-for="mess in message.answer.sub_category" :key="mess.id"
                            @click.prevent.stop="getSubCategoryByCategory(mess.id)">
                          <span>{{ mess.name }}</span>
                          <svg role="img" width="14" height="14" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg>
                        </li>
                      </div>
                      <hr>
                      <div class="service__block">
                        <li class="service" v-for="mess in message.answer.questions" :key="mess.id"
                            @click.prevent.stop="getAnswerByQuestion(mess.id)">
                          <span>{{ mess.question }}</span>
                          <!-- <svg role="img" width="14" height="14" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg> -->
                        </li>
                      </div>
                    </ul>
                    <ul class="services" v-else-if="message.type === 'question'">
                      <li class="service" v-for="mess in message.answer" :key="mess.id"
                          @click.prevent.stop="getAnswerByQuestion(mess.id)">
                        <span>{{ mess.question }}</span>
                        <!-- <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-arrow-next"></use>
                        </svg> -->
                      </li>
                    </ul>
                    <span class="message_text" v-else-if="message.type === 'errorAnswer'">
                      {{ $t(message.answer) }} <span @click.prevent.stop="openAssistant('assistant-call')" class="call_btn">{{$t("requestCall")}}</span>
                    </span>
                    <span v-else class="message_text">{{ message.answer }}</span>
                  </div>
                </div>
                <div id="messageBlock"></div>
              </div>
            </div>
            <div class="assistant__footer assistant__footer_bordered">
              <div class="assistant__long">
                <form id="chat-form" method="post" name="chat-form" @keyup.enter.prevent.stop="submitQuestion">
                  <div class="form-group">
                    <label class="form-label form-label_hidden" for="user-chat-af">{{$t("inputMessage")}}</label>
                    <textarea class="form-control form-control_textarea assistant__chat-input"
                              :class="{is_invalid: invalid}" v-model="question" name="user-chat-af" id="user-chat-af"
                              :placeholder='$t("inputMessage")' required="required"></textarea>
                  </div>
                </form>
              </div>
              <div class="assistant__short">
                <button class="btn btn_icon btn_transparent" type="submit" @click.prevent.stop="submitQuestion"
                        form="chat-form" :aria-label='$t("send")'><span class="btn__icon svg-icon" aria-hidden="true">
                        <svg role="img" width="24" height="24" aria-hidden="true">
                          <use xlink:href="#svg-icon-send"></use>
                        </svg></span></button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <button class="btn assistant__toggler" @click.prevent.stop="toggleModal" type="button"
              :aria-label='$t("switchAssistant")'><span class="btn__icon svg-icon" aria-hidden="true">
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-arrow-next"></use>
              </svg></span></button>
    </div>
    <!-- <div class="links" :class="{ links_open: isLinksOpen }">
      <div class="link_item link_btn" @click="openLinks()" :title='$t("contactUs")'>
        <img src="images/svg/link.svg" alt="">
        <span class="glint"></span>
      </div>
      <a href="mailto:support@ttc.kz" class="link_item link">
        <img src="images/svg/mail.svg" alt="">
      </a>
      <a href="https://t.me/MyTTC_bot" class="link_item link">
        <img src="images/svg/telegram.svg" alt="">
      </a>
      <a href="https://wa.me/77710100191" class="link_item link">
        <img src="images/svg/whatsapp.svg" alt="">
      </a>
    </div> -->
  </div>
</template>
<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import useValidate from "@vuelidate/core";
import { required, email, sameAs, minLength } from "@vuelidate/validators";

export default {
  data() {
    return {
      v$: useValidate(),
      question: '',
      invalid: false,
      isAgree: false,
      loading: false,
      isLinksOpen: false,
      dataForACallBack: {
        fio: '', 
        phone: '', 
        // address: '', 
        question: '', 
        // iin: ''
      }
    }
  },
  validations() {
  	return {
      dataForACallBack: {
        fio: { required }, 
        phone: { required }, 
        // address: { required }, 
        question: { required }, 
        // iin: { required }
      }
    }
  },
  methods: {
    ...mapActions({
      getProfile: 'profile/getProfile',
      getPersonalData: 'personaldata/getPersonalData',
      getCategory: 'assistant/getCategory',
      getQuestion: 'assistant/getQuestion',
      getSubCategory: 'assistant/getSubCategory',
      getAnswer: 'assistant/getAnswer',
      setQuestion: 'assistant/submitQuestion',
      requestCall: 'assistant/requestACall',
    }),
    ...mapMutations({
      setAssistantType: 'assistant/setAssistantType'
    }),
    getQuestionByCategory(categoryId) {
      this.getQuestion(categoryId)
          .then(this.scrollToEnd())
    },
    getSubCategoryByCategory(categoryId) {
      this.getSubCategory(categoryId)
          .then(this.scrollToEnd())
    },
    getAnswerByQuestion(questionId) {
      this.getAnswer(questionId)
          .then(this.scrollToEnd())
    },
    submitQuestion() {
      this.invalid = false
      if (!this.question) {
        this.invalid = true
        return
      }
      this.setQuestion(this.question)
          .then(this.question = '')
          .then(this.scrollToEnd())
    },
    toggleModal() {
      const bodyElem = document.querySelector('body')
      bodyElem.classList.contains('assistant-hide') ? this.openModal() : this.closeModal()
    },
    openModal() {
      const bodyElem = document.querySelector('body')
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
      } else {
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
        bodyElem.classList.contains('assistant-open') || bodyElem.classList.add("assistant-open")
      }
      this.openAssistant('current')
    },
    openAssistant(assistantType) {
      this.setAssistantType(assistantType)
      if (assistantType === 'assistant-chat') {
        this.getCategory() 
      }
    },
    closeModal() {
      const bodyElem = document.querySelector('body')
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('assistant-hide') || bodyElem.classList.add("assistant-hide")
      } else {
        bodyElem.classList.contains('assistant-open') && bodyElem.classList.remove("assistant-open")
      }
      this.openAssistant('assistant-profile')
    },
    scrollToEnd() {
      document.getElementById("messageBlock").scrollIntoView({block: "end", behavior: "smooth"});
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    },
    requestACall() {
      const {dataForACallBack} = this
      if (dataForACallBack.phone.startsWith("+7") && dataForACallBack.phone.includes("(")){
        dataForACallBack.phone = dataForACallBack.phone.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
      }
      dataForACallBack.iin = this.profile.profile.iin
      dataForACallBack.email = this.profile.email
      this.v$.$validate() 
  		if (!this.v$.$error) { 
        this.loading = true
        this.requestCall(dataForACallBack)
          .then(res => {
            if(res === 200 || res === 201){
              this.openAssistant('assistant-call-success')
              this.dataForACallBack.fio = '', 
              this.dataForACallBack.phone = '', 
              this.dataForACallBack.question = '', 
              this.isAgree = false,
              // this.dataForACallBack.iin = ''
              this.v$.$reset()
            }else{
              this.openAssistant('assistant-call-error')
            } 
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    subStr(str) {
      return str.includes('_') ? str.slice(str.indexOf('_')+1) : str
    },
    formatOBK(obk){
      return (+obk.toFixed(2)).toLocaleString('ru');
    },
    nursultanToAstana(cityName = ''){
      return cityName.toLowerCase().includes('нур-султан') ? 'Астана' : cityName;
    },
    // openLinks(){
    //   this.isLinksOpen = !this.isLinksOpen
    // }
  },
  computed: {
    ...mapGetters({
      profile: 'profile/profileData',
      personalData: 'personaldata/personalData',
      dialog: 'assistant/dialog',
      isAuthenticated: 'authorization/isAuthenticated',
      isOpen: 'assistant/assistantStatus'
    }),
  },
  created() {
    if (this.isAuthenticated) {
      if(this.isEmpty(this.profile)){
        this.getProfile();
      }
      if(this.isEmpty(this.personalData)){
        this.getPersonalData();
      }
    }
  },
}
</script>
<style scoped>
.assistant__content{
  height: max-content;
}
.services {
  list-style: none;
  padding: 10px;
}
.assistant__message{
  background-color: #E9F0ED;
  padding: 14px 0 1px 0;
  box-shadow: 0px 8px 16px rgba(31, 50, 42, 0.03);
  border-radius: 0px 12px 12px 12px;
}
.assistant__message_user{
  background-color: #E9F0ED;
  box-shadow: 0px 8px 16px rgba(31, 50, 42, 0.03);
  border-radius: 12px 12px 0px 12px;
}
.service {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 15px;
  border-bottom: 1px solid #B4C2BB;
  color: #212222;
  cursor: pointer;
}
.service:hover:not(.service__title) {
  color: #118143;
  transition: all .2s ease-in-out;
}
.service:last-child {
  border: none;
}
.assistant__avatar {
  padding: 7px;
}
.is_invalid{
    border: 1px solid #dd2727;
    opacity: 1;
    visibility: inherit;
}
.message_text{
  display: block;
  padding: 5px 15px 19px;
  color: #212222;
}
#messageBlock {
  height: 200px;
}
.is_disabled{
    background-color: #ddd;
    color: #a7a7a7;
    border-color: #ddd;
}
hr{
  color:#B4C2BB;
}
.call_btn{
  cursor: pointer;
  background: linear-gradient(45deg, #10934F 0%, #83C555 100%);
  box-shadow: 0px 8px 40px rgba(18, 148, 79, 0.3);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  display: block;
  text-align: center;
  margin-top: 8px;
}
.call_btn:hover{
  transition: all .2s ease-in-out;
  background: linear-gradient(45deg, #13B05F 0%, #94DE60 100%);
}
.service__title{
  color: #8B8C8C;;
}
.links{
  position: fixed;
  z-index: 9;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: row-reverse;
  column-gap: 10px;
  width: 55px;
  overflow: hidden;
  align-items: center;
  transition: all .2s ease-in;
  border-radius: 30px;
}
.link_item{
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.link{
  min-width: 45px;
  height: 45px;
}
.link>img{
  width: 100%;
}
.link_btn{
  min-width: 55px;
  height: 55px;
  background-color: #2A9C54;
}
.link_btn>img{
  width: 50%;
}
.links_open{
  width: 220px;
}
.glint {
  position: absolute;
  top: -100%;
  left: -100%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0) 40%, rgba(255,255,255,0.2) 60%);
  animation: glintAnimation 2s linear infinite;
}

@keyframes glintAnimation {
  0% {
    transform: rotate(45deg) translate(-150%, -150%);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(45deg) translate(150%, 150%);
    opacity: 0;
  }
}
@media (max-width: 1200px) {
  .links{
    bottom: 70px;
  }
}
</style>